module.exports = __webpack_public_path__ + "static/media/memory.ba12e6c2.svg";